<pre>{{session | json }}</pre>
<hr class="svnl-hr">
<pre>{{order | json }}</pre>
<button (click)="updateSession()">Update Session</button><br/>
<button (click)="clearSession()">Clear Session</button><br/>
